<template>
    <datepicker
        monday-first
        :language="ru"
        clear-button
        :required="required"
        :value="valueStr"
        :input-class="{'error-glow': error, 'date-input': true}"
        @input="emitInput"
        :disabled="readonly"
        placeholder="(Не задано)"
    />
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import {ru} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import AutoFieldMixin from '../../mixins/AutoField'

export default {
  name: 'DateInput',
  mixins: [AutoFieldMixin],
  components: { Datepicker },
  props: {
    value: {
      default: Number
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
        type: Boolean,
        default: false
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      ru: ru,
      valueStr: ''
    }
  },
  computed: {
    isValueTypeValid() {
      return typeof this.value === 'number'
    },
    defaultValue() {
      return NaN
    }
  },
  methods: {
    preEmitHook(rawValue) {
      this.valueStr = rawValue
    },
    // eslint-disable-next-line no-unused-vars
    valueToSendFromEvent(e){
      return moment(this.valueStr).unix()
    },
    valueIsEmpty() {
      return this.valueStr === null
    }
  }
}
</script>

<style lang="sass">
.date-input
    border-radius: pxToRem(5px)
    border: 1px solid $grey
    font-size: $base-font-size
    font-weight: 300
    padding: gridSteps(1)
    margin-bottom: gridSteps(2)

    &:focus
        outline-color: $brand-blue
</style>
